
<script>
import vue2Dropzone from "vue2-dropzone";
import { vendorService, customerService, promoCodeService, orderService, deliveryZoneService} from "../../../services";
import { required , requiredIf, email} from "vuelidate/lib/validators";
import config from "../../../config";
import Multiselect from "vue-multiselect";
import { error_message, success_message } from "../../../Helper/helper";
import DropzonePopup from "../../../components/widgets/dropzone-popup";
import VueGoogleAutocomplete from 'vue-google-autocomplete';
export default {
    components: { VueGoogleAutocomplete, vueDropzone: vue2Dropzone, DropzonePopup, vendorService, customerService, Multiselect, promoCodeService, orderService, deliveryZoneService},
    data() {
        return {
            checked: true,
            isLoading: false,
            file1: null,
            tmpCategoryImage: "",
            url: null,
            config: config,
            business_type :"",
            is_contact : "",
            timezones: "",
            customer_id: "",
            customer: [],
            customerCount: 0,
            customer_email: "",
            shipping_data: [],
            same_address: 1,
            ship_address: "",
            customer_data:[],
            orderData:[],
            shipping_add_data:[],
            billing_add_data:[],
            company_data:[],
            contact_person:[],
            typeform: {
                user_role: "Private",
                user_name: "",
                last_name: "",
                email: "",
                mobile_number: "",
                city: "",
                street: "",
                apartment: "",
                street_no: "",
                postal_code: "",
                address: "",
                name : "",
                hrb : "",
                vat : "",
                latitude : "",
                longitude : "",
                person_first_name : "",
                person_last_name : "",
                person_phone : "",
                person_email : "",
                is_contact_person : "1",
                business_user_name: "",
                business_last_name: "",
                business_email: "",
                business_mobile_number: "",
                notes: "",
                parking_place: 1,
                is_elevator: 0,
                customer_id: "",
                is_billing_address:"1",
                bill_city: "",
                bill_street: "",
                bill_apartment: "",
                bill_street_no: "",
                bill_postal_code: "",
                bill_address: "",
                shipping_address:"",
                sub_total_2: 0,
            },
        };
    },
    validations: {
        typeform: {
            
            address: {
                required,
            },
            user_name: {
                required : requiredIf(function(form){
                    return this.business_type == 'Private';
                }),
            },
            customer_id: {
                required : requiredIf(function(form){
                    return this.business_type != 'Private' && this.business_type != 'Business';
                }),
            },
            last_name: {
                required : requiredIf(function(form){
                    return this.business_type == 'Private';
                }),
            },
            email: {
                required : requiredIf(function(form){
                    return this.business_type == 'Private';
                }),
                email
            },
            mobile_number: {
                required : requiredIf(function(form){
                    return this.business_type == 'Private';
                }),
            },
            city: {
                required : requiredIf(function(form){
                    return this.shipping_data == 0 && this.shipping_data == '';
                }),
            },
            street: {
                required : requiredIf(function(form){
                    return this.shipping_data == 0 && this.shipping_data == '';
                }),
            },
            street_no: {
                required : requiredIf(function(form){
                    return this.shipping_data == 0 && this.shipping_data == '';
                }),
            }, 
            postal_code: {
                required : requiredIf(function(form){
                    return this.shipping_data == 0 && this.shipping_data == '';
                }),
            },
            business_user_name: {
                required : requiredIf(function(form){
                    return this.business_type == 'Business';
                }),
            },
            business_last_name: {
                required : requiredIf(function(form){
                    return this.business_type == 'Business';
                }),
            },
            business_email: {
               required : requiredIf(function(form){
                    return this.business_type == 'Business';
                }),
                email
            },
            business_mobile_number: {
                required : requiredIf(function(form){
                    return this.business_type == 'Business';
                }),
            },
            name: {
                required : requiredIf(function(form){
                    return this.business_type == 'Business';
                }),
            },
            hrb: {
                required : requiredIf(function(form){
                    return this.business_type == 'Business';
                }),
            },
            vat: {
                required : requiredIf(function(form){
                    return this.business_type == 'Business';
                }),
            },
            person_first_name: {
                required : requiredIf(function(form){
                    return this.business_type == 'Business' && this.is_contact == '1';
                }),
            },
            person_last_name: {
                required : requiredIf(function(form){
                    return this.business_type == 'Business' && this.is_contact == '1';
                }),
            },
            person_phone: {
                required : requiredIf(function(form){
                    return this.business_type == 'Business' && this.is_contact == '1';
                }),
            }, 
            person_email: {
                required : requiredIf(function(form){
                    return this.business_type == 'Business' && this.is_contact == '1';
                }),
                email
            },
            bill_city: {
                required : requiredIf(function(form){
                    return this.same_address == '0';
                }),
            },
            bill_street: {
                required : requiredIf(function(form){
                    return this.same_address == '0';
                }),
            },
            bill_street_no: {
                required : requiredIf(function(form){
                    return this.same_address == '0';
                }),
            },
            bill_address: {
                required : requiredIf(function(form){
                    return this.same_address == '0';
                }),
            },
            bill_postal_code: {
                required : requiredIf(function(form){
                    return this.same_address == '0';
                }),
            },
        },
    },
    mounted(){
        // this.getOrderById();
        this.getOrderDetailById();
    },
    methods: {
        check: function(e) {
            if(e.target.checked == true){
                this.same_address = 1;
            }else{
               this.same_address = 0; 
            }
        },
        toggleSelected(value) {
            this.customer_email = value.email;
            if(this.customer_email.length > 0){
                orderService.getCustomerByEmail({email: this.customer_email}).then((response) => {
                    this.shipping_data = response.data.result;
                    this.typeform.shipping_address = response.data.result.length;
                });
            }
        },
        clearAllCustomer() {
            this.customer_id = [];
        },
        asyncFindCustomer(query) {
            this.isLoading = true;
            promoCodeService.getCustomer({search: query}).then((response) => {
                this.customer = response.data.result;
                this.isLoading = false;
            });
        },
        validate(){
            this.typeform.$touch();
            var isValid = !this.typeform.$invalid;
            this.$emit('on-validate', this.typeform, isValid);
            return isValid;
        },
        vatNumber(e){   
            const floating = /^[A-Za-z0-9 ]+$/;
            let char = String.fromCharCode(e.keyCode);
            if (floating.test(char)) return true;
            else e.preventDefault();
        },
        alphabetic(e){   
            const floating = /^[A-Za-z ]+$/;
            let char = String.fromCharCode(e.keyCode);
            if (floating.test(char)) return true;
            else e.preventDefault();
        },
        hrbNumber(e){   
            const floating = /^[A-Za-z0-9-]+$/;
            let char = String.fromCharCode(e.keyCode);
            if (floating.test(char)) return true;
            else e.preventDefault();
        },
        contactNumber(evt) {
            let val1 = evt.target.value;
            if (!(evt.keyCode == 43 || (evt.keyCode >= 48 && evt.keyCode <= 57))) {
                evt.preventDefault();
            }
            let partlen = val1.split("+").length - 1;
            if (evt.keyCode == 43 && partlen > 0) {
                evt.preventDefault();
            } else if (evt.keyCode == 43 && (evt.target.selectionStart !== undefined && evt.target.selectionStart !== 0)) {
                evt.preventDefault();
            }
        },
        onStatusChange(){
            this.is_contact = this.typeform.is_contact_person;
        },
        getLanguage(){
            vendorService.getLanguage()
            .then(response => {
                this.timezones  = response.data.result.timezone;
            });
        },
        getAddressData: function (addressData, placeResultData, id) {
            this.address = addressData;
            
            this.typeform.address = placeResultData.formatted_address;
            this.typeform.city = addressData.locality;
            this.typeform.state = addressData.administrative_area_level_1;
            this.typeform.country = addressData.country;
            this.typeform.latitude = addressData.latitude;
            this.typeform.longitude = addressData.longitude;
            this.typeform.postal_code = addressData.postal_code;
            this.typeform.street_no = addressData.street_number;
            this.typeform.street = addressData.route;
        },
        getBillAddress: function (addressData, placeResultData, id) {
            this.address = addressData;
            
            this.typeform.bill_address = placeResultData.formatted_address;
            this.typeform.bill_city = addressData.locality;
            this.typeform.bill_latitude = addressData.latitude;
            this.typeform.bill_longitude = addressData.longitude;
            this.typeform.bill_postal_code = addressData.postal_code;
            this.typeform.bill_street_no = addressData.street_number;
            this.typeform.bill_street = addressData.route;
        },
        checkPostalCode(e) {
            deliveryZoneService.checkPostalCode({ postal_code:this.typeform.postal_code, email:this.customer_email, customer_type: this.business_type})
            .then(response => {
                if (response.data.code === 101) {
                error_message(response.data.message);
                }
            });
        },
        Onclick(event){
           this.typeform.address = event.target.value;
        },
        addToShippingData(data){
            this.typeform.latitude = data.latitude;
            this.typeform.longitude = data.longitude;
            this.typeform.shipping_first_name = data.first_name;
            this.typeform.shipping_last_name = data.last_name;
            this.typeform.address = data.address;
            this.typeform.mobile_number = data.phone;
        },
        // getOrderById(){
        //     orderService.getOrderById({order_id : this.$route.params.order_id}).then((response) => {
        //         if (response.data.code === 200) {
        //             var result = response.data.result;
        //             this.customer_data = result.customer;
        //             if(result.customer.user_role == 1){
        //                 this.business_type = 'Private';
        //             }else{
        //                 this.business_type = 'Business'
        //             }
        //             this.typeform.sub_total_2 = result.sub_total;
                  
                  
        //             this.shipping_add_data = result.ship_address;
        //             this.billing_add_data = result.order_address;
        //             this.company_data = result.customer_company;
                   
        //             if(this.shipping_add_data != ""){
        //                 this.addToShippingData(this.shipping_add_data)
        //             }
        //             if(result.customer_company){
        //                 if(result.customer_company.contact_person != null){
        //                     this.contact_person = result.customer_company.contact_person;
        //                     this.is_contact = 1;
        //                     this.typeform.is_contact_person = 1;
        //                 }else{
        //                     this.contact_person = "";
        //                     this.is_contact = 0;
        //                     this.typeform.is_contact_person = 0;
        //                 }
                        
        //             }
        //             if(result.order_address_id == result.order_billing_address_id){
        //                 this.typeform.is_billing_address = 1;
        //                 this.same_address = 1;
        //             }else{
        //                 this.typeform.is_billing_address = 0;
        //                 this.same_address = 0;
        //             }
        //         }else{
        //             this.$router.push({ name: "orders-list" });
        //             error_message(response.data.message);
        //         }
        //     });
        // },
        getOrderDetailById(){
            orderService.getOrderDetailById({order_id : this.$route.params.order_id}).then((response) => {
               
                if (response.data.code === 200) {
                    var result = response.data.result;
                    this.orderData = result;
                    this.customer_data = result.customer;
                    this.customer_data.user_role = result.customer.role;
                
                    if(result.customer.role == 1){
                        this.business_type = 'Private';
                    }else{
                        this.company_data.name = result.customer.name;
                        this.company_data.hrb = result.customer.hrb;
                        this.company_data.vat = result.customer.vat;
                        this.company_data.mobile_number = result.customer.person_phone;
                        this.business_type = 'Business'

                        if(result.customer.is_contact_person == 1){
                            this.contact_person.email = result.customer.person_email;
                            this.contact_person.first_name = result.customer.person_first_name;
                            this.contact_person.last_name = result.customer.person_last_name;
                            this.contact_person.phone = result.customer.person_phone;
                            this.is_contact = 1;
                            this.typeform.is_contact_person = 1;
                        }else{
                            this.contact_person = "";
                            this.is_contact = 0;
                            this.typeform.is_contact_person = 0;
                        }
                    }
                    // this.typeform.sub_total_2 = result.sub_total;
                  
                  
                    this.shipping_add_data = result.address;
                    this.billing_add_data = result.billing_address;
                    // this.company_data = result.customer_company;
                   
                    if(this.shipping_add_data != ""){
                        this.addToShippingData(this.shipping_add_data)
                    }
                    // if(result.customer_company){
                    //     if(result.customer_company.contact_person != null){
                    //         this.contact_person = result.customer_company.contact_person;
                    //         this.is_contact = 1;
                    //         this.typeform.is_contact_person = 1;
                    //     }else{
                    //         this.contact_person = "";
                    //         this.is_contact = 0;
                    //         this.typeform.is_contact_person = 0;
                    //     }
                        
                    // }
                    if(result.order_address_id == result.order_billing_address_id){
                        this.typeform.is_billing_address = 1;
                        this.same_address = 1;
                    }else{
                        this.typeform.is_billing_address = 0;
                        this.same_address = 0;
                    }
                }else{
                    this.$router.push({ name: "orders-list" });
                    error_message(response.data.message);
                }
            });
        }
    },
};
</script>
<template>
    <form @submit.prevent="addCustomer">

        <!-- Business Type Info Start -->
        <div class="card">
            <div class="card-body">
                <h4 class="card-title">{{ trans.get('__JSON__.Business Type Info') }}</h4>
                <p class="card-title-desc"></p>
                <div class="row">
                    <div class="col-sm-6">
                        <div class="form-group">
                            <select
                                name="user_role"
                                class="custom-select"
                                id="user_role"
                                v-model="customer_data.user_role"
                                :disabled="true"
                            >
                                <option value="">{{ trans.get('__JSON__.Select Section Design Type') }}</option>
                                <option value="1" selected>Private</option>
                                <option value="5">Business</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Business Type Info End -->

        <!-- Private Start -->
        <div class="card" v-if="this.business_type == 'Private'">
            <div class="card-body">
                <h4 class="card-title">{{ trans.get('__JSON__.Private Customer') }}</h4>
                <p class="card-title-desc"></p>
                
                <div class="row">
                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.First Name')}}</label>
                            <input
                                id="user_name"
                                v-model="customer_data.user_name"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.First Name')"
                                name="user_name"
                                :disabled="true"
                            />
                            <!-- <div v-if="customer_data.user_name.$error" class="invalid-feedback">
                                <span v-if="!customer_data.user_name.required">{{ trans.get('__JSON__.Please enter first name') }}</span>
                            </div> -->
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Last Name')}}</label>
                            <input
                                id="last_name"
                                v-model="customer_data.last_name"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Last Name')"
                                name="last_name"
                                :disabled="true"
                            />
                            <!-- <div v-if="typeform.last_name.$error" class="invalid-feedback">
                                <span v-if="!typeform.last_name.required">{{ trans.get('__JSON__.Please enter last name') }}</span>
                            </div> -->
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Email')}}</label>
                            <input
                                id="email"
                                v-model="customer_data.email"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Email')"
                                name="email"
                                :disabled="true"
                            />
                            <!-- <div v-if="typeform.email.$error" class="invalid-feedback">
                                <span v-if="!typeform.email.required">{{ trans.get('__JSON__.Please enter email') }}</span>
                                <span v-if="!typeform.email.email" v-cloak>{{ trans.get('__JSON__.This value should be a valid email') }}</span>
                            </div> -->
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Phone')}}</label>
                            <input
                                maxlength="12"
                                minlength="9"
                                id="mobile_number"
                                v-model="customer_data.mobile_number"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Phone')"
                                name="mobile_number"
                                @keypress="contactNumber($event)"
                                :disabled="true"
                            />
                            <!-- <div v-if="typeform.mobile_number.$error" class="invalid-feedback">
                                <span v-if="!typeform.mobile_number.required">{{ trans.get('__JSON__.Please enter contact number') }}</span>
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Private End -->

        <!-- Business Start -->
        <div class="card" v-if="this.business_type == 'Business'">
            <div class="card-body">
                <h4 class="card-title">{{ trans.get('__JSON__.Company Details') }}</h4>
                <p class="card-title-desc"></p>
                
                <div class="row">
                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Company Name')}}</label>
                            <input
                                id="name"
                                v-model="company_data.name"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Company Name')"
                                name="name"
                                :disabled="true"
                            />
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.CEO First Name')}}</label>
                            <input
                                id="business_user_name"
                                v-model="customer_data.user_name"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.CEO First Name')"
                                name="business_user_name"
                                :disabled="true"
                            />
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.CEO Last Name')}}</label>
                            <input
                                id="business_last_name"
                                v-model="customer_data.last_name"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.CEO Last Name')"
                                name="business_last_name"
                                :disabled="true"
                            />
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Email')}}</label>
                            <input
                                id="business_email"
                                v-model="customer_data.email"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Email')"
                                name="business_email"
                                :disabled="true"
                            />
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.HRB')}}</label>
                            <input
                                minlength="5"
                                id="hrb"
                                v-model="company_data.hrb"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.HRB')"
                                name="hrb"
                                v-on:keypress="hrbNumber($event,company_data.hrb)"
                                :disabled="true"
                            />
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Vat')}}</label>
                            <div class="input-group mb-2">
                                <div class="input-group-prepend">
                                    <div class="input-group-text h-100 cust-input">DE</div>
                                </div>
                                <input
                                    maxlength="13"
                                    id="vat"
                                    v-model="company_data.vat"
                                    type="text"
                                    class="form-control"
                                    :placeholder="trans.trans('__JSON__.Vat')"
                                    name="vat"
                                    v-on:keypress="vatNumber($event,company_data.vat)"
                                    :disabled="true"
                                />
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Phone')}}</label>
                            <input
                                maxlength="12"
                                minlength="9"
                                id="business_mobile_number"
                                v-model="customer_data.mobile_number"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Phone')"
                                name="business_mobile_number"
                                @keypress="contactNumber($event)"
                                :disabled="true"
                            />
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <b-form-group id="input-group-2" :label="trans.get('__JSON__.Is Contact Person')" label-for="Is Contact Person" >
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="swtich-data">
                                        <label class="switch">
                                        <input
                                            type="checkbox"
                                            id="togBtn"
                                            class="switch-on"
                                            name="is_contact_person"
                                            v-model="typeform.is_contact_person"
                                            true-value="1"
                                            false-value="0"
                                            @change="onStatusChange"
                                            :disabled="true"
                                        />
                                        <div class="slider round">
                                            <!--ADDED HTML -->
                                            <span class="on">{{ trans.get('__JSON__.Yes') }}</span>
                                            <span class="off">{{ trans.get('__JSON__.No') }}</span>
                                            <!--END-->
                                        </div>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </b-form-group>
                    </div>

                </div>
            </div>
        </div>
        <!-- Business End -->

        <!-- Compant Start -->
        <div class="card" v-if="this.business_type == 'Business' && this.is_contact == 1">
            <div class="card-body">
                <h4 class="card-title">{{ trans.get('__JSON__.Contact Person') }}</h4>
                <p class="card-title-desc"></p>
                
                <div class="row">

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.First Name')}}</label>
                            <input
                                id="person_first_name"
                                v-model="contact_person.first_name"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.First Name')"
                                name="person_first_name"
                                :disabled="true"
                            />
                            <!-- <div v-if="typeform.person_first_name.$error" class="invalid-feedback">
                                <span v-if="!typeform.person_first_name.required">{{ trans.get('__JSON__.Please enter first name') }}</span>
                            </div> -->
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Last Name')}}</label>
                            <input
                                id="person_last_name"
                                v-model="contact_person.last_name"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Last Name')"
                                name="person_last_name"
                                :disabled="true"
                            />
                            <!-- <div v-if="typeform.person_last_name.$error" class="invalid-feedback">
                                <span v-if="!typeform.person_last_name.required">{{ trans.get('__JSON__.Please enter last name') }}</span>
                            </div> -->
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Phone')}}</label>
                            <input
                                maxlength="12"
                                minlength="9"
                                id="person_phone"
                                v-model="contact_person.phone"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Phone')"
                                name="person_phone"
                                @keypress="contactNumber($event)"
                                :disabled="true"
                            />
                            <!-- <div v-if="typeform.person_phone.$error" class="invalid-feedback">
                                <span v-if="!typeform.person_phone.required">{{ trans.get('__JSON__.Please enter contact number') }}</span>
                            </div> -->
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Email')}}</label>
                            <input
                                id="person_email"
                                v-model="contact_person.email"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Email')"
                                name="person_email"
                                :disabled="true"
                            />
                            <!-- <div v-if="typeform.person_email.$error" class="invalid-feedback">
                                <span v-if="!typeform.person_email.required">{{ trans.get('__JSON__.Please enter email') }}</span>
                                <span v-if="!typeform.person_email.email" v-cloak>{{ trans.get('__JSON__.This value should be a valid email') }}</span>
                            </div> -->
                        </div>
                    </div> 
                </div>
            </div>
        </div>
        <!-- Business End -->

        <!-- Address Start -->
        <div class="card">
            <div class="card-body">
                <h4 class="card-title">{{ trans.get('__JSON__.Address') }}</h4>
                <p class="card-title-desc"></p>
                <div class="row" v-if="this.shipping_data.length > 0">
                    <div class="col-sm-6">
                        <div class="form-group">
                            <div v-for="(v,i) in shipping_data" :key="i">
                                <div class="form-check mb-3">
                                    <input class="form-check-input" type="radio" name="address_radio" id="address_radio" v-bind:value="v.id" :checked="v.is_primary_address == 1" @change="Onclick($event)"/>
                                    <label class="form-check-label" for="address_radio">{{v.first_name}} {{v.last_name}} - {{v.address}}, {{v.postal_code}}</label>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" v-if="this.shipping_data.length == 0 && this.shipping_data.length == ''">
                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="control-label required">{{ trans.get('__JSON__.Full address') }}</label>
                            <vue-google-autocomplete
                                ref="address"
                                id="address"
                                v-model="shipping_add_data.shipping_address"
                                name="address"
                                type="text"
                                class="form-control"
                                placeholder="Please type your address"
                                v-on:placechanged="getAddressData"
                                :disabled="true"
                            >
                            </vue-google-autocomplete>
                            <!-- <div v-if="typeform.address.$error" class="invalid-feedback">
                                <span v-if="!typeform.address.required">{{ trans.get('__JSON__.Please enter address') }}</span>
                            </div> -->
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label>{{ trans.trans('__JSON__.Floor')}}</label>
                            <input
                                maxlength="2"
                                minlength="1"
                                id="floor"
                                v-model="shipping_add_data.floor"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Floor')"
                                name="floor"
                                @keypress="contactNumber($event)"
                                :disabled="true"
                            />
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Street')}}</label>
                            <input
                                id="street"
                                v-model="shipping_add_data.street"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Street')"
                                name="street"
                                v-on:keypress="alphabetic($event,typeform.street)"
                                :disabled="true"
                            />
                            <!-- <div v-if="typeform.street.$error" class="invalid-feedback">
                                <span v-if="!typeform.street.required">{{ trans.get('__JSON__.Please enter street name') }}</span>
                            </div> -->
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Street Number')}}</label>
                            <input
                                maxlength="11"
                                minlength="1"
                                id="street_no"
                                v-model="shipping_add_data.street_no"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Street Number')"
                                name="street_no"
                                :disabled="true"
                            />
                            <!-- @keypress="contactNumber($event)"<div v-if="typeform.street_no.$error" class="invalid-feedback">
                                <span v-if="!typeform.street_no.required">{{ trans.get('__JSON__.Please enter street number') }}</span>
                            </div> -->
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Postal Code')}}</label>
                            <input
                                maxlength="5"
                                minlength="5"
                                id="postal_code"
                                v-model="shipping_add_data.postal_code"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Postal Code')"
                                name="postal_code"
                                v-on:focus="checkPostalCode"
                                @keypress="contactNumber($event)"
                                :disabled="true"
                            />
                            <!-- <div v-if="typeform.postal_code.$error" class="invalid-feedback">
                                <span v-if="!typeform.postal_code.required">{{ trans.get('__JSON__.Please enter postal code') }}</span>
                            </div> -->
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.City')}}</label>
                            <input
                                id="city"
                                v-model="shipping_add_data.city"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.City')"
                                name="city"
                                v-on:keypress="alphabetic($event,typeform.city)"
                                :disabled="true"
                            />
                            <!-- <div v-if="typeform.city.$error" class="invalid-feedback">
                                <span v-if="!typeform.city.required">{{ trans.get('__JSON__.City Name Error') }}</span>
                            </div> -->
                        </div>
                    </div>

                    <!-- <div class="col-md-4 vendor-status" v-if="this.business_type == 'Private'">
                        <b-form-group id="input-group-2" :label="trans.get('__JSON__.Parking Place')" label-for="Parking Place" >
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="swtich-data">
                                        <label class="switch">
                                        <input
                                            type="checkbox"
                                            id="togBtn"
                                            class="switch-on"
                                            name="parking_place"
                                            v-model="shipping_add_data.parking_place"
                                            true-value="1"
                                            false-value="0"
                                            :disabled="true"
                                        />
                                        <div class="slider round">
                                            <span class="on">{{ trans.get('__JSON__.Yes') }}</span>
                                            <span class="off">{{ trans.get('__JSON__.No') }}</span>
                                        </div>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </b-form-group>
                    </div> -->

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label>{{ trans.trans('__JSON__.Message From Customer')}}</label>
                            <textarea
                                rows="5"
                                id="notes"
                                v-model="shipping_add_data.message"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Message From Customer')"
                                name="notes"
                                :disabled="true"
                            ></textarea>
                        </div>
                    </div>

                    <!-- <div class="col-sm-4" v-if="this.business_type == 'Business'">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Parking Note')}}</label>
                            <textarea
                                rows="5"
                                id="parking_note"
                                v-model="shipping_add_data.parking_note"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Parking Note')"
                                name="parking_note"
                                :disabled="true"
                            ></textarea>
                        </div>
                    </div> -->
                </div>
                <div class="d-flex align-items-center gap-2">
                    <input 
                        type="checkbox" 
                        id="checkbox" 
                        v-model="typeform.is_billing_address" 
                        :checked="this.typeform.is_billing_address == 1" 
                        @click="check($event)"
                        true-value="1"
                        false-value="0"
                        :disabled="true">
                        
                    <label for="checkbox" class="mb-0"> Billing address is same as shipping address</label>
                </div>
            </div>
        </div>
        <!-- Address End -->

        <!-- Billing Address Start -->
        <div class="card" v-if="this.same_address == 0">
            <div class="card-body">
                <h4 class="card-title">{{ trans.get('__JSON__.Billing Address') }}</h4>
                <p class="card-title-desc"></p>
                <div class="row">
                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="control-label required">{{ trans.get('__JSON__.Full address') }}</label>
                            <vue-google-autocomplete
                                ref="bill_address"
                                id="bill_address"
                                v-model="billing_add_data.shipping_address"
                                name="bill_address"
                                type="text"
                                class="form-control"
                                placeholder="Please type your address"
                                v-on:placechanged="getBillAddress"
                                :disabled="true"
                            >
                            </vue-google-autocomplete>
                            <!-- <div v-if="typeform.bill_address.$error" class="invalid-feedback">
                                <span v-if="!typeform.bill_address.required">{{ trans.get('__JSON__.Please enter address') }}</span>
                            </div> -->
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label>{{ trans.trans('__JSON__.Floor')}}</label>
                            <input
                                maxlength="2"
                                minlength="1"
                                id="bill_apartment"
                                v-model="billing_add_data.floor"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Floor')"
                                name="bill_apartment"
                                @keypress="contactNumber($event)"
                                :disabled="true"
                            />
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Street')}}</label>
                            <input
                                id="bill_street"
                                v-model="billing_add_data.street"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Street')"
                                name="bill_street"
                                v-on:keypress="alphabetic($event,typeform.street)"
                                :disabled="true"
                            />
                            <!-- <div v-if="typeform.bill_street.$error" class="invalid-feedback">
                                <span v-if="!typeform.bill_street.required">{{ trans.get('__JSON__.Please enter street name') }}</span>
                            </div> -->
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Street Number')}}</label>
                            <input
                                maxlength="11"
                                minlength="1"
                                id="bill_street_no"
                                v-model="billing_add_data.street_no"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Street Number')"
                                name="bill_street_no"
                                :disabled="true"
                            />
                            <!--  @keypress="contactNumber($event)" <div v-if="typeform.bill_street_no.$error" class="invalid-feedback">
                                <span v-if="!typeform.bill_street_no.required">{{ trans.get('__JSON__.Please enter street number') }}</span>
                            </div> -->
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Postal Code')}}</label>
                            <input
                                maxlength="5"
                                minlength="5"
                                id="bill_postal_code"
                                v-model="billing_add_data.postal_code"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Postal Code')"
                                name="bill_postal_code"
                                v-on:focus="checkPostalCode"
                                @keypress="contactNumber($event)"
                                :disabled="true"
                            />
                            <!-- <div v-if="typeform.bill_postal_code.$error" class="invalid-feedback">
                                <span v-if="!typeform.bill_postal_code.required">{{ trans.get('__JSON__.Please enter postal code') }}</span>
                            </div> -->
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.City')}}</label>
                            <input
                                id="bill_city"
                                v-model="billing_add_data.city"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.City')"
                                name="bill_city"
                                v-on:keypress="alphabetic($event,typeform.city)"
                                :disabled="true"
                            />
                            <!-- <div v-if="typeform.bill_city.$error" class="invalid-feedback">
                                <span v-if="!typeform.bill_city.required">{{ trans.get('__JSON__.City Name Error') }}</span>
                            </div> -->
                        </div>
                    </div>
                    <div class="col-md-4 vendor-status">
                        <b-form-group id="input-group-2" :label="trans.get('__JSON__.Parking Place')" label-for="Parking Place" >
                            <div class="row">
                                <div class="col-sm-6">
                                    <select
                                        name="parking_place"
                                        v-on:keypress="alphabetic($event,typeform.parking_place)"
                                        class="custom-select"
                                        id="parking_place"
                                        v-model="typeform.parking_place"
                                    >
                                        <option value="">
                                            {{ trans.get("__JSON__.Select Parking Place") }}
                                        </option>
                                        <option value="1">Frontdoor</option>
                                        <option value="0">Basement</option>
                                    </select>
                                </div>
                            </div>
                        </b-form-group>
                    </div>

                    <div class="col-md-4 vendor-status">
                        <b-form-group id="input-group-2" :label="trans.get('__JSON__.Elevator Available')" label-for="Elevator Available" >
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="swtich-data">
                                        <label class="switch">
                                        <input
                                            type="checkbox"
                                            id="togBtn"
                                            class="switch-on"
                                            name="is_elevator"
                                            v-model="typeform.is_elevator"
                                            true-value="1"
                                            false-value="0"
                                        />
                                        <div class="slider round">
                                            <span class="on">{{ trans.get('__JSON__.Yes') }}</span>
                                            <span class="off">{{ trans.get('__JSON__.No') }}</span>
                                        </div>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </b-form-group>
                    </div>

                    <!-- <div class="col-md-4 vendor-status" v-if="this.business_type == 'Private'">
                        <b-form-group id="input-group-2" :label="trans.get('__JSON__.Parking Place')" label-for="Parking Place" >
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="swtich-data">
                                        <label class="switch">
                                        <input
                                            type="checkbox"
                                            id="togBtn"
                                            class="switch-on"
                                            name="parking_place"
                                            v-model="billing_add_data.parking_place"
                                            true-value="1"
                                            false-value="0"
                                            :disabled="true"
                                        />
                                        <div class="slider round">
                                            <span class="on">{{ trans.get('__JSON__.Yes') }}</span>
                                            <span class="off">{{ trans.get('__JSON__.No') }}</span>
                                        </div>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </b-form-group>
                    </div> -->
                    
                    <!-- <div class="col-sm-4" v-if="this.business_type == 'Business'">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Parking Note')}}</label>
                            <textarea
                                rows="5"
                                id="parking_note"
                                v-model="billing_add_data.parking_note"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Parking Note')"
                                name="parking_note"
                                :disabled="true"
                            ></textarea>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>
        <!-- Address End -->
    </form>
</template>